import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "mChatVoice",
  ...userVuex.mapState(["userInfo", "token"]),
  ...walletVuex.mapState(["isMobile", "deviceType"]),
  data() {
    return {
      socket: null,
      recorder: null,
      player: null,
      isPlaying: false,
      isStarting: false,
      conversationStart: false,
      voiceQueue: [],
      text: "",
      status: ""
    };
  },
  methods: {
    downsampleBuffer(buffer, sampleRate, outSampleRate) {
      if (outSampleRate === sampleRate) {
        const result = new Int16Array(buffer.length);
        for (let i = 0; i < buffer.length; i++) {
          const s = Math.max(-1, Math.min(1, buffer[i]));
          result[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
        }
        return result;
      }
      const sampleRateRatio = sampleRate / outSampleRate;
      const newLength = Math.round(buffer.length / sampleRateRatio);
      const result = new Int16Array(newLength);
      let offsetResult = 0;
      let offsetBuffer = 0;
      while (offsetResult < newLength) {
        const nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
        let accum = 0;
        let count = 0;
        for (let i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
          accum += buffer[i];
          count++;
        }
        const avg = accum / count;
        const s = Math.max(-1, Math.min(1, avg));
        result[offsetResult] = s < 0 ? s * 0x8000 : s * 0x7fff;
        offsetResult++;
        offsetBuffer = nextOffsetBuffer;
      }
      return result;
    },
    int16ArrayToBase64(buffer) {
      let binary = "";
      const bytes = new Uint8Array(buffer.buffer);
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    },
    base64ToInt16(base64String) {
      const binaryString = atob(base64String.replace(/[\n\r]/g, ""));
      const buffer = new ArrayBuffer(binaryString.length);
      const uint8Array = new Uint8Array(buffer);
      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }
      return buffer;
    },
    async startRecording(websocket) {
      const audioContext = new window.AudioContext();
      const sampleRate = audioContext.sampleRate;
      const TARGET_SAMPLE_RATE = 16000;
      const BUFFER_SIZE = 8192;
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true
      });
      const sourceNode = audioContext.createMediaStreamSource(stream);
      const scriptProcessor = audioContext.createScriptProcessor(BUFFER_SIZE, 1, 1);
      scriptProcessor.onaudioprocess = event => {
        const channelData = event.inputBuffer.getChannelData(0);
        const downsampledBuffer = this.downsampleBuffer(channelData, sampleRate, TARGET_SAMPLE_RATE);
        const base64Data = this.int16ArrayToBase64(downsampledBuffer);
        if (websocket.readyState === WebSocket.OPEN && this.conversationStart) {
          websocket.send(JSON.stringify({
            type: "user_audio",
            data: base64Data
          }));
        }
      };
      sourceNode.connect(scriptProcessor);
      scriptProcessor.connect(audioContext.destination);
      return scriptProcessor;
    },
    playAudio() {
      if (this.isPlaying && this.voiceQueue.length > 0) {
        if (this.conversationStart) this.status = "AI正在说...";
        const audioContext = new window.AudioContext();
        const TARGET_SAMPLE_RATE = 16000;
        const pcmArrayBuffer = this.voiceQueue.shift();
        const int16View = new Int16Array(pcmArrayBuffer);
        const float32Data = new Float32Array(int16View.length);
        for (let i = 0; i < int16View.length; i++) {
          float32Data[i] = int16View[i] / 32768;
        }
        const audioBuffer = audioContext.createBuffer(1, float32Data.length, TARGET_SAMPLE_RATE);
        audioBuffer.getChannelData(0).set(float32Data);
        this.player = audioContext.createBufferSource();
        this.player.buffer = audioBuffer;
        this.player.connect(audioContext.destination);
        this.player.start();
        this.player.onended = () => this.playAudio();
      } else {
        if (this.conversationStart) this.status = "AI正在听...";
      }
    },
    async start() {
      this.voiceQueue = [];
      this.text = "";
      this.status = "拨号中...";
      this.isStarting = true;
      console.log("this.token", this.$parent.token);
      const token = this.$parent.token;
      this.socket = new WebSocket(`https://tapi.legendai.vip/ws/${token}`);
      // this.socket = new WebSocket(`https://tapi.legendai.vip/ws/U_2_c7fc9468-bfb6-4050-a1ac-e47358f823cc`);
      this.socket.binaryType = "arraybuffer";
      this.socket.onopen = async () => {
        this.recorder = await this.startRecording(this.socket);
      };
      this.socket.onmessage = event => {
        if (typeof event.data === "string") {
          const data = JSON.parse(event.data);
          if (data.type === "cmd") {
            this.text += `${data.code}: ${data.message}<br /><br />`;
            if (data.code === 10001) {
              this.conversationStart = true;
              this.status = "已接通";
            } else if (data.code === 10003) {
              this.conversationStart = false;
              this.status = "通话已断开";
            }
            this.isPlaying = false;
            if (this.player) {
              this.player.stop();
              this.player.disconnect();
              this.player = null;
            }
          } else if (data.type === "agent_message") {
            this.text += `AI: ${data.data}<br /><br />`;
          } else if (data.type === "user_message") {
            this.text += `用户: ${data.data}<br /><br />`;
          } else if (data.type === "agent_audio") {
            const audio = this.base64ToInt16(data.data);
            this.voiceQueue.push(audio);
            if (!this.isPlaying) {
              this.isPlaying = true;
              this.playAudio();
            }
          }
        }
      };
      this.socket.onclose = () => {
        this.status = "连接已断开";
        this.conversationStart = false;
        this.isStarting = false;
        this.isPlaying = false;
        if (this.player) {
          this.player.stop();
          this.player.disconnect();
          this.player = null;
        }
      };
    },
    stop() {
      if (this.socket) {
        this.socket.close();
      }
      if (this.recorder) {
        this.recorder.disconnect();
        this.recorder.onaudioprocess = null;
        this.recorder = null;
      }
      this.isStarting = false;
    }
  },
  beforeDestroy() {
    this.stop();
  }
};